<template>
    <div class="fl like_or_bad_button_common good_contain" :class="{contain_click:item.user_helpful_status !=0 }">
        <div class="fabulous_hand_common" @click.stop="useFulAndunUseFul(item)">
            <div :class="{good_click:item.user_helpful_status !=0 }"></div>
            <span>{{item.total_helpful_num == 0 ? '赞' : item.total_helpful_num | toFixed }}</span>
        </div>
        <popup :pop-obj="errobj" v-if="errobj.type"></popup>
    </div>
</template>
<script>
import popup from './popup.vue'

export default {
    replace: true,
    name:'good',
    props:['goodNum'],
    components:{ popup },
    data(){
        return {
            item:this.goodNum,
            errobj: {
                    type: '',
                    errorMsg: ''
                }
        }
    },
    mounted() {
        console.log(11111, this.item)
    },
    methods: {
        useFulAndunUseFul(item, isUseful) {
            if (item.user_helpful_status != 0) {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '你已经赞赏过了！'
                }
                return;
            }
            if (item.user_useless_status != 0) {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '你已经吐槽过了！'
                }
                return;
            }
            var useType = 'is_useful'
            var useNum = 'total_helpful_num'
            var isClickUse = 'user_helpful_status'
            var postData = {
                    action: 'book_review_whether_useful',
                    product_id: item.product_id,
                    main_product_id: item.main_product_id,
                    comment_id: item.comment_id,
                    [useType]: 1
                }
            if(item.reply_id){
                postData = Object.assign(postData,{reply_id:item.reply_id})
            }
            this.$http({
                method: 'post',
                url: 'my.php',
                data: postData
            }).then((result) => {
                var data = result.data;
                if (data.errorCode == 0) {
                    item[isClickUse] = true
                    item[useNum] = parseFloat(item[useNum]) + 1
                } else if (data.errorCode == 96) {
                    window.location.href = login_url
                }
                this.errobj = {
                    type: 'pop',
                    errorMsg: data.errorMsg
                }
            }).catch(() => {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })
        }
    },
    filters:{
        toFixed(value){
            value += '';
            if(value === '赞') return value
            if(value.length > 4){
                return (value/10000).toFixed(1) + '万';
            }else{
                return value
            }
        }
    }
}
</script>
<style lang="stylus">
    .fabulous_hand_common
        line-height:0.75rem
        div
            width:0.7rem
            height:0.75rem
            background:url('../assets/images/good.png') no-repeat
            background-size:100% 100%
            display:inline-block
            margin-top:1px
            vertical-align:middle
        span
            font-size:0.625rem
            color:#969696
            margin-left:-2px
        .good_click
            background:url('../assets/images/goodclick.png') no-repeat
            background-size:100% 100%
</style>



// WEBPACK FOOTER //
// good.vue?59b303ed